import React, { useEffect, useState } from "react";
import styles from "./Experience.module.sass";
import TextInput from "../../../components/TextInput";
import {
	PatchExperience,
	PatchExperienceCancel,
} from "../../../Services/lib/admin";
import { UseApi } from "../../../hooks/use-api";
import cn from "classnames";
import { InputController } from "../../../hooks/input-controller";
import Modal from "../../../components/Modal";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import Schedule from "../../../components/Schedule";
import Loader from "../../../components/Loader";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";

const ExperienceComponent = ({
	data,
	readOnly = false,
	refresh = () => {},
}) => {
	console.log(data);
	const [{ isLoading }, patchExperience] = UseApi({
		service: PatchExperience,
	});

	const [{ isLoading: isLoadingCancel }, patchExperienceCancel] = UseApi({
		service: PatchExperienceCancel,
	});

	const [body, setBody] = useState({
		id: data._id,
		userFirstName:
			data.userinfo?.firstName || data.nftOwner?.firstName || "",
		userLastName: data.userinfo?.lastName || data.nftOwner?.lastName || "",
		adminNote: data.adminNote || "",
		scheduledDate: data.scheduledDate || "",
		location: data.location || "",
	});

	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();

	const [startDate, setStartDate] = useState(
		data.scheduledDate ? new Date(data.scheduledDate) : ""
	);

	const userFirstName = InputController("userFirstName", setBody);
	const userLastName = InputController("userLastName", setBody);
	const adminNote = InputController("adminNote", setBody);
	const location = InputController("location", setBody);
	useEffect(() => {
		setBody((p) => {
			return {
				...p,
				scheduledDate: startDate,
			};
		});
	}, [startDate]);

	const reject = async () => {
		const { id, adminNote } = body;
		const res = await patchExperienceCancel({
			id,
			adminNote,
		});
		if (res) {
			ToastEmitter({
				msg: "Successfully rejected",
				type: "success",
			});
			refresh();
		}
	};
	const schedule = async () => {
		const res = await patchExperience({
			...body,
			stringDate: body.scheduledDate.toLocaleString(),
			status: "SCHEDULED",
		});
		if (res) {
			ToastEmitter({
				msg: "Successfully scheduled",
				type: "success",
			});
			refresh();
		}
	};

	return (
		<div className={styles.container}>
			<div>Contact info</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>First name</div>
				<TextInput
					disabled={readOnly}
					defaultValue={
						data.userinfo?.firstName ||
						data.nftOwner?.firstName ||
						""
					}
					{...userFirstName}
				/>
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Last name</div>
				<TextInput
					disabled={readOnly}
					defaultValue={
						data.userinfo?.lastName || data.nftOwner?.lastName || ""
					}
					{...userLastName}
				/>
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Email</div>
				<TextInput disabled value={data.userinfo?.email} />
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Phone</div>
				<TextInput disabled value={data.userinfo?.phoneNumber} />
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Note</div>
				<TextInput
					disabled
					value={data.userinfo?.nftOwnerNote}
					textarea
				/>
			</div>
			<div>Set schedule</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Location</div>
				<TextInput
					disabled={readOnly}
					defaultValue={data.location || ""}
					{...location}
				/>
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Date</div>
				<TextInput
					disabled={readOnly}
					value={startDate.toLocaleString()}
					onClick={() => {
						if (!readOnly) startOpen();
					}}
					onChangeInput={() => {
						startOpen();
					}}
				/>
			</div>
			<div className={styles.inputWrap}>
				<div className={styles.name}>Note</div>
				<TextInput
					disabled={readOnly}
					defaultValue={data.adminNote || ""}
					textarea
					{...adminNote}
				/>
			</div>
			{data.status !== "CANCELLED" && !readOnly ? (
				<div className={styles.btns}>
					{data.status === "REQUESTED" && (
						<button
							onClick={reject}
							className={cn("button-small button-stroke-red", {
								disabled: isLoading || isLoadingCancel,
							})}
						>
							{isLoadingCancel ? (
								<Loader className={styles.loader} />
							) : null}
							Reject
						</button>
					)}
					<button
						onClick={schedule}
						className={cn("button-small", {
							disabled: isLoading || isLoadingCancel,
						})}
					>
						{isLoading ? (
							<Loader className={styles.loader} />
						) : null}
						{data.status === "SCHEDULED" ? "Update" : "Schedule"}
					</button>
				</div>
			) : null}
			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					note=""
					onClick={startClose}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			</Modal>
		</div>
	);
};

export default ExperienceComponent;
